/* eslint @typescript-eslint/no-explicit-any: 0 */

import { Link } from 'react-router';

import { setNavigationContext } from '~/utils/navigationContext';
import SearchResultClickEvent from '~/events/SearchResultClickEvent';
import useRootData from '~/hooks/useRootData';
import type { ProductSearchResultProps } from '~/legacy/types';
import { IMAGE_TYPES, RECORD_SUBTYPES } from '~/legacy/utils';

import GranularResponsiveImage from './GranularResponsiveImage';

const getPath = ({
  canonical_path,
  slug
}: {
  canonical_path: string;
  slug: string;
}) => (canonical_path ? canonical_path : `/products/${slug}/`);

const ProductSearchResult = ({
  onClick,
  position,
  insightsFields = {},
  query,
  hit,
  hit: {
    name,
    objectID,
    images: {
      featured: { alt: featuredAlt, original_img_url } = {
        alt: '',
        original_img_url: ''
      }
    } = {}
  },
  sub_type
}: ProductSearchResultProps) => {
  const image = original_img_url ? (
    <GranularResponsiveImage
      alt={featuredAlt || name}
      url={original_img_url}
      title={name}
      responsiveImageType={IMAGE_TYPES.SEARCH_RESULT}
      preserveRatio={sub_type === RECORD_SUBTYPES.CLOTHING}
    />
  ) : (
    ''
  );

  const link = {
    pathname: getPath(hit as any),
    state: { hit, insightsFields }
  };

  const { isBot } = useRootData();

  const handleSearchResultClick = (e: React.MouseEvent<HTMLElement>) => {
    setNavigationContext({ position, surfaceSource: 'search' });

    new SearchResultClickEvent({
      isBot,
      product_name: name,
      search_term: query
    }).send();
    onClick(e);
  };

  return (
    <Link
      onClick={(e) => {
        handleSearchResultClick(e);
      }}
      to={link}
      className="search-panel__list-item"
      rel="product"
    >
      <div className="search-panel__image">{image}</div>
      <section className="search-panel__description">
        <h5
          className="search-panel__description-heading"
          id={`aria-product-title--${objectID}`}
        >
          {name}
        </h5>
      </section>
    </Link>
  );
};

export default ProductSearchResult;
